import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/yelloop.svg'


const _withScopeId = n => (_pushScopeId("data-v-30e30dcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "sub-info d-flex flex-column justify-content-start p-4"
}
const _hoisted_3 = {
  key: 1,
  class: "sub-info d-flex flex-column justify-content-start p-4"
}

import { translate } from '@/languages/i18n'
import { ref, watch } from 'vue'
import Link from '@/components/link/index.vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: 'ログイン',
  },
  color: String,
},
  setup(__props) {

const route = useRoute()



const links = ref([
  {
    title: translate('forgotPassword'),
    path: 'forgot_password',
  },
  {
    title: translate('canNotReceiveMail'),
    path: 'forgot_email',
  },
])
const linkSA80 = ref([
  {
    title: translate('forgotPassword'),
    path: 'forgot_password',
  },
])

watch(
  () => route.name,
  () => {
    links.value = links.value.map((e) => ({
      ...e,
      path: route.path.split('/')[1] === 'community' ? `/community/${e.path}` : `/alumni/${e.path}`,
    }))
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([' d-flex justify-content-between mb-4 pb-3 align-items-center', __props.color === 'orange' ? 'border-bottom-orange' : 'border-bottom-green'])
    }, [
      _createElementVNode("h1", {
        class: _normalizeClass(['fw-bold', __props.color])
      }, _toDisplayString(__props.title), 3),
      _hoisted_1
    ], 2),
    _renderSlot(_ctx.$slots, "default"),
    (_unref(route).path !== '/alumni/login' && _unref(route).path !== '/community/users/login')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
            return (_openBlock(), _createBlock(Link, {
              key: link.path,
              path: link.path,
              title: link.title
            }, null, 8, ["path", "title"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(route).path === '/alumni/login' || _unref(route).path === '/community/users/login')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkSA80.value, (link) => {
            return (_openBlock(), _createBlock(Link, {
              key: link.path,
              path: link.path,
              title: link.title
            }, null, 8, ["path", "title"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})